/**
 * Copyright (c) Microsoft. All rights reserved.
 */

 // tslint:disable:export-name

import { HANDLED_MESSAGE_ACK, UNHANDLED_MESSAGE_ACK } from './Constants';
import { HandleMessageResult, LogProvider, MessageHandler, TrouterMessage } from './Interfaces';

/**
 * Registry of message handlers.
 * Safely executes individual handlers and aggregates results
 */
export class MessageHandlerRegistry {
    private messageHandlers: MessageHandler[] = [];

    public constructor(private logger: LogProvider) {
    }

    public register(handler: MessageHandler) {
        if (this.messageHandlers.some(item => item === handler)) {
            throw new Error('Registering the same handler twice is not allowed');
        }
        this.messageHandlers.push(handler);
    }

    public clear() {
        this.logger.debug('Clearing message handlers');
        this.messageHandlers = [];
    }

    public active(): boolean {
        return (this.messageHandlers.length > 0);
    }

    public handleMessage(message: TrouterMessage): HandleMessageResult {
        const unhandledMessageResult = {
            resultCode: UNHANDLED_MESSAGE_ACK,
            isHandled: false
        };

        for (const messageHandler of this.messageHandlers) {
            const result = this.safeExecuteHandle(messageHandler, message);
            if (result !== undefined && (result.isHandled === undefined || result.isHandled)) {
                if (result.resultCode === undefined) {
                    result.resultCode = HANDLED_MESSAGE_ACK;
                }

                return result;
            }
        }

        return unhandledMessageResult;
    }

    private safeExecuteHandle(handler: MessageHandler, message: TrouterMessage): HandleMessageResult | undefined {
        try {
            return handler.handleMessage(message);
        } catch (exception) {
            this.logger.warn(`A trouter message handler is throwing exceptions. exception: ${exception}`);

            return undefined;
        }
    }
}



// WEBPACK FOOTER //
// ./lib_temp/MessageHandler.ts